import React from "react"
import classNames from "classnames"
import styles from "./NextBackgroundImg.module.css"
import { useIntersection } from "../../../ui/utilities/observer"
import { urlFor } from "../../services/images"

export type BackgroundSize = "contain" | "cover"
export type BackgroundSizePosition = "center"
export type BackgroundAttachment = "fixed"

export interface ResponsiveImages {
  xs?: any
  sm?: any
  md?: any
  lg?: any
  xl?: any
  "2xl"?: any
  "3xl"?: any
}

export interface SanityNextBackgroundImgProps {
  id?: string
  component?: keyof JSX.IntrinsicElements
  asset?: any
  responsiveImages?: ResponsiveImages
  children?: any
  className?: string
  backgroundSize?: BackgroundSize
  backgroundPosition?: BackgroundSizePosition
  backgroundAttachment?: BackgroundAttachment
  useOriginalImg?: boolean
  style?: React.CSSProperties
}

const SanityNextBackgroundImg = ({
  id,
  asset,
  children,
  className,
  backgroundSize,
  backgroundPosition,
  backgroundAttachment,
  useOriginalImg,
  responsiveImages,
  style,
}: SanityNextBackgroundImgProps) => {
  const ref = React.useRef<HTMLDivElement>(null)
  const { isVisible } = useIntersection(ref, "300px")
  const [showImage, setShowImage] = React.useState(false)

  React.useEffect(() => {
    if (isVisible) {
      setShowImage(true)
    }
  }, [isVisible])

  return (
    <div
      id={id}
      ref={ref}
      style={{
        ...(asset
          ? {
              ["--bg-original" as any]: `url(${urlFor(asset)})`,
              ["--bg-img-xs" as any]: `url(${urlFor(
                responsiveImages?.xs ?? asset
              )})`,
              ["--bg-img-sm" as any]: `url(${urlFor(
                responsiveImages?.sm ?? responsiveImages?.xs ?? asset
              )})`,
              ["--bg-img-md" as any]: `url(${urlFor(
                responsiveImages?.md ??
                  responsiveImages?.sm ??
                  responsiveImages?.xs ??
                  asset
              )})`,
              ["--bg-img-lg" as any]: `url(${urlFor(
                responsiveImages?.lg ??
                  responsiveImages?.md ??
                  responsiveImages?.sm ??
                  responsiveImages?.xs ??
                  asset
              )})`,
              ["--bg-img-xl" as any]: `url(${urlFor(
                responsiveImages?.xl ??
                  responsiveImages?.lg ??
                  responsiveImages?.md ??
                  responsiveImages?.sm ??
                  responsiveImages?.xs ??
                  asset
              )})`,
              ["--bg-img-2xl" as any]: `url(${urlFor(
                responsiveImages?.["2xl"] ??
                  responsiveImages?.xl ??
                  responsiveImages?.lg ??
                  responsiveImages?.md ??
                  responsiveImages?.sm ??
                  responsiveImages?.xs ??
                  asset
              )})`,
              ["--bg-img-3xl" as any]: `url(${urlFor(
                responsiveImages?.["3xl"] ??
                  responsiveImages?.["2xl"] ??
                  responsiveImages?.xl ??
                  responsiveImages?.lg ??
                  responsiveImages?.md ??
                  responsiveImages?.sm ??
                  responsiveImages?.xs ??
                  asset
              )})`,
            }
          : undefined),
        ...style,
      }}
      className={classNames(
        styles.root,
        {
          [styles.originalImg]: useOriginalImg,
          [styles.contain]: backgroundSize === "contain",
          [styles.cover]: backgroundSize === "cover",
          [styles.positionCenter]: backgroundPosition === "center",
          [styles.attachmentFixed]: backgroundAttachment === "fixed",
          [styles.bgHidden]: !showImage,
        },
        className
      )}
    >
      {children}
    </div>
  )
}

export default SanityNextBackgroundImg
